/**
 * Pauses the execution for the specified amount of time.
 * @param time - The time to wait in milliseconds.
 * @returns A promise that resolves after the specified time has elapsed.
 */
const wait = (time: number) => new Promise((resolve) => setTimeout(resolve, time));
export default wait;
